
import React, { useContext } from "react";
import { useTheme } from "@emotion/react";
import { ThemeProvider, createTheme } from "@mui/material";
import { useMemo } from "react";
import AppContext from "../../../context/Context";

const SikkaTableWrapper = ({children}) => {
    const {isDark} = useContext(AppContext);
    const SikkaTableTheme = useMemo(() => createTheme({
        palette:{
            mode: isDark? "dark" : "light",
            primary: {
                main: '#3076dc',
            },
            secondary: {
                main: "#fff",
            },
            background: {
                default: isDark ? "#132238" : "rgb(250, 250, 250)"
            },
        }
    }), []);
    return(
        <ThemeProvider theme={SikkaTableTheme}>
            {children}
        </ThemeProvider>
    )
}
export default SikkaTableWrapper;